module.exports = __webpack_public_path__ + "assets/img/34@3x.7dcf7bc1.png";